import type { BladeStackState } from '../shell/types';

// The audit workbench's landing stack (HUB-504): a single batch-queue blade. Seeded
// into the backendless preview so the coding-audit batch queue renders on load.
//
// FOCUS-MODE-FIRST (HUB-504 slice 2): the coding audit is a full-screen single-view
// app, not a blade-canvas. Every audit view — batch queue, batch detail, case review
// — renders full-bleed in the shell's `focus` presentation mode, and drilling
// deeper (queue → batch → review) or stepping back navigates WITHIN focus (the stack
// is a focus drill-stack, surfaced as the breadcrumb). Seeding `focus` here means the
// queue lands full-bleed and a single click on a batch opens the detail full-bleed —
// never the two-column explorer layout where two xwide blades overflow the canvas.
export const AUDIT_DEFAULT_STACK: BladeStackState = {
  blades: [
    {
      key: 'audit-batches',
      title: 'Code evaluation — batches',
      eyebrow: 'Evaluation queue',
      width: 'xwide',
    },
  ],
  activeIndex: 0,
  mode: 'focus',
};

// The program-metrics stack: agent-vs-coder scoreboard, full-bleed like every
// other audit view. A sibling landing stack rather than a blade opened from the
// queue — it answers a different question ("how is the program doing") than the
// queue does ("what do I review next"), and reaching it should not require
// drilling through work.
export const AUDIT_METRICS_STACK: BladeStackState = {
  blades: [
    {
      key: 'audit-metrics',
      title: 'Program metrics',
      eyebrow: 'Code evaluation',
      width: 'xwide',
    },
  ],
  activeIndex: 0,
  mode: 'focus',
};
